import React from "react";
import { Menu } from "@default/general-components/navigation/menu";
import PropTypes from "prop-types";
import RBXLogo from "@default/assets/rbx-company/RBX-Logo-white.svg?url";
import { Link } from "react-router-dom";
import FooterPartners from "@default/js/footer/components/footer-partners";
import { useSelector } from "react-redux";

const RBXFooter = ({ footerConfig, mainPageConfig }) => {
  const microSiteFrontPage = useSelector(
    (reduxStore) => reduxStore.appStore.microSiteFrontPage
  );
  const currentLanguage = useSelector((state) => state.i18n.currentLanguage);

  return (
    <footer id="page-footer" className="rbx">
      <div className="container-fluid">
        {footerConfig && (
          <div className="row">
            <div className="col-12 col-lg-6 footer main">
              <div className="footer-menu row">
                <div className="col-12 col-lg-6">
                  <img src={RBXLogo} className="rbx-logo" alt={"Logo RBX"} />
                  {!!footerConfig.fieldRbxFooterText && (
                    <div
                      className="text"
                      dangerouslySetInnerHTML={{
                        __html: footerConfig.fieldRbxFooterText,
                      }}
                    />
                  )}
                </div>
                <div className="col-12 col-lg-6">
                  {!!footerConfig.fieldSitemap?.links.length && (
                    <Menu
                      menuTree={footerConfig.fieldSitemap}
                      ariaLabel={"footer menu"}
                    />
                  )}
                </div>
                {!!footerConfig.fieldLegalMenu?.links.length && (
                  <div className="col-12 col-lg-6 offset-lg-6 legal-menu-wrapper">
                    <Menu
                      menuTree={footerConfig.fieldLegalMenu}
                      ariaLabel={"legal menu"}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className={"col-12 col-lg-6 footer brands"}>
              {!!footerConfig.fieldBrands?.length && (
                <div className="brands-wrapper row">
                  {!!footerConfig.fieldBrandsHeadline && (
                    <h4 className="col-12 col-lg-9 offset-lg-2 headline-s brand-headline">
                      {footerConfig.fieldBrandsHeadline}
                    </h4>
                  )}
                  <ul className="col-12 col-lg-11 offset-lg-1">
                    {footerConfig.fieldBrands.map((brand, brandIndex) => (
                      <li key={brandIndex}>
                        <Link
                          to={
                            currentLanguage === "de"
                              ? brand.url.path.replace("/", "/#")
                              : brand.url.path.replace(
                                  "/en/",
                                  "/en/" + microSiteFrontPage + "#"
                                )
                          }
                        >
                          {brand.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="row">
                <div className="col-12 col-lg-11 offset-lg-1">
                  <FooterPartners content={mainPageConfig} />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </footer>
  );
};

/*RBXFooter.propTypes = {
  footerConfig: PropTypes.func,
  socialMediaConfig: PropTypes.func
};*/

export default RBXFooter;
